<template>
    <div id="single" v-if="!isLoading">
        <div class="container">
            <ul class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link :to="{name: 'Home'}">Página Principal</router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link :to="{name: 'Busca'}">Consultórios</router-link>
                </li>
                <li class="breadcrumb-item">    
                    <span>{{ rede.nomeRede }}</span>
                </li>
            </ul>
        </div>
        <section class="header-single">
            <div class="container">
              <div class="element-box">
                <div class="row">
                    <div class="col-md-2 text-center">
                        <div class="avatar-w">
                            <img alt="" class="img-fluid" :src="`${baseUrl}/redeImagemLogo?q=${rede.nomeRede}`" :onerror="`this.src='${require('@/img/icon-drachei-alpha.svg')}'`">
                        </div>
                        <rate :length="5" :value="rede.rate" :readonly="true"></rate>
                    </div>
                    <div class="col-md-6">
                        <h4>{{ rede.nomeRede }}</h4>
                        <div class="label"></div>
                        
                        <div class="dados">
                            <h6 v-if="rede.telefone" class="mt-2 mb-2"><i class="ti-mobile"></i> {{ rede.telefone}}</h6>
                            <a href="#" class="location"><i class="ti-location-pin"></i> <span>{{ endereco }}</span></a>
                        </div>
                        <br>
                        <div class="features mb-4">
                            <a v-if="rede.agendamento" href="#" class="badge badge-primary mr-sm-2">Agendamento</a>
                            <a v-if="rede.delivery" href="#" class="badge badge-primary mr-sm-2">Em Domicílio</a>
                        </div>
                        <div class="social">
                            <a href="#"><i class="os-icon os-icon-twitter"></i></a>
                            <a href="#"><i class="os-icon os-icon-facebook"></i></a>
                            <a href="#"><i class="os-icon os-icon-instagram"></i></a>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="embed-responsive embed-responsive embed-responsive-16by9">
                            <iframe class="embed-responsive-item" :src="`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_KEY}&q=${endereco}`" width="400" height="200" frameborder="0" style="border:0" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </section>  
        <div class="content-w">
          <transition name="content" mode="out-in">
            <div class="container">
                <div class="element-box">
                    <div class="os-tabs-w">
                        <tab-clinica></tab-clinica>
                    </div>
                </div>
            </div>
          </transition>
        </div>
    </div>
</template>
<script>
import TabClinica from './TabClinica'
import http from 'axios'
export default {
  components: {
    TabClinica
  },
  data () {
    return {
      isLoading: true,
      GOOGLE_MAPS_KEY: 'AIzaSyDkKIKv_5RypDjSm7Fy20vldKy_BhYyQYI'
    }
  },
  async created () {
    await this.$store.dispatch('setSingleRede', this.$route.query)
    this.isLoading = false
  },
  computed: {
    rede () {
      return this.$store.getters.redeSingle
    },
    baseUrl () {
      return http.defaults.baseURL
    },
    endereco () {
      let unidade = this.rede
      return `${unidade.localAtendimento}, número ${unidade.numero}, ${unidade.bairro}${unidade.complemento ? `,${unidade.complemento}` : ''}, ${unidade.cidade} - ${unidade.uf}`
    },

    isClinica () {
      return this.$store.getters.redeSingle.tipoRede.indexOf('CLINICA') >= 0 || this.$store.getters.redeSingle.tipoRede.indexOf('MEDICO') >= 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/single-consultorio/Single.vue